import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-300">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
                <Link to="/" className="no-underline text-background-50 hover:text-primary-400 transition-colors">555电影</Link>
              </h4>
              <p className="text-sm leading-relaxed text-background-400">
                555电影网提供海量高清电影免费在线观看，最新热门电影、院线大片一网打尽，播放流畅不缓冲，每日更新。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">电影分类</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-100 mb-4">热门分类</h4>
              <ul className="space-y-2">
                <li><Link to="/category/action" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">动作片</Link></li>
                <li><Link to="/category/comedy" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">喜剧片</Link></li>
                <li><Link to="/category/scifi" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">科幻片</Link></li>
                <li><Link to="/category/animation" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">动画片</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-100 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line"></i>
                  <span>contact@555dy.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-customer-service-2-line"></i>
                  <span>在线客服 7x24小时</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; 2026 555电影网 555dy.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors no-underline" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors no-underline" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors no-underline" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}